import React from 'react';
import PropTypes from 'prop-types';

import withModal from '../../../../../../../components/global/modal/withModal';
import { getIdentityName } from '../../../../../../../util/identity';
import Button from '../../../../../../../components/global/Button';
import { getAsset } from '../../../../../../../util/assets';

const propTypes = {
  identity: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  nextIdentity: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  onNext: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

const IdentityTagSelectionSuccess = ({
  identity,
  nextIdentity,
  onNext,
  onDismiss,
}) => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center">
      <img
        src={getAsset('/waldo-icon.svg')}
        alt="Waldo"
        width="48"
        className="mb-2"
      />
      <h3>Awesome!</h3>
      <p className="text-center">
        Thanks, you just made finding <b>{getIdentityName(identity)}</b> a lot
        easier for me!
      </p>

      {nextIdentity && (
        <Button
          data-testid="btn-next-identity"
          btnBlock
          btnStyle="success-vibrant"
          className="text-extra-bold mt-3"
          onClick={onNext}
        >
          Continue with {getIdentityName(nextIdentity)} &rarr;
        </Button>
      )}

      <Button
        btnBlock
        btnStyle="link"
        className="text-center mt-2"
        onClick={onDismiss}
      >
        Review {getIdentityName(identity)}&apos;s info one more time
      </Button>
    </div>
  );
};

IdentityTagSelectionSuccess.propTypes = propTypes;

export { IdentityTagSelectionSuccess as IdentityTagSelectionSuccessComponent };

export default withModal(IdentityTagSelectionSuccess, {
  hideHeader: true,
  size: 'xs',
  dismissible: false,
});
